export default "__VITE_ASSET__Cab8cTVV__"